import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFacility } from '../../../context/FacilityContext';
import { useAuth } from '../../../context/AuthContext';

const DevelopmentOnly = ({ children, fallback }) => {
  const { facilityId } = useFacility();
  const { currentUser } = useAuth();
  const [isSuperadmin, setIsSuperadmin] = useState(false);

  useEffect(() => {
    if (currentUser && currentUser.getIdTokenResult) {
      currentUser
        .getIdTokenResult()
        .then((idTokenResult) => {
          setIsSuperadmin(idTokenResult.claims?.superadmin === true);
        })
        .catch((error) => {
          console.error('Error fetching token claims:', error);
        });
    }
  }, [currentUser]);

  const isTestFacility =
    facilityId === 'test-facility' || facilityId === 'test-facility-two';

  if (isTestFacility) {
    return children;
  }

  if (isSuperadmin) {
    return (
      <>
        <p>
          Module in development. Only superadmins can use it outside Test
          Facilities.
        </p>
        {children}
      </>
    );
  }

  return fallback;
};

DevelopmentOnly.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

DevelopmentOnly.defaultProps = {
  fallback: null,
};

export default DevelopmentOnly;
